<template>
    <div class="container">
        <div class="row">
            <div class="text-center fs-1 pt-5 pb-4 text-uppercase oswald-bold">
                Featured Shows
            </div>
            <div v-for="(show, index) in showsData" :key="index"
                :class="`col-md-4  d-flex flex-column align-items-center justify-content-start pb-2 px-3`">

                <div class="position-relative">
                    <img :src="`${$API_ASSETS}${show.banner_image.id}.png`" class="img-fluid py-2" />
                    <img v-if="show.family_friendly"
                        src="https://api.atlasimprov.com/assets/6804e410-9e3b-4e8d-af7f-05804cb7ec29.png"
                        class="position-absolute" style="bottom: -15%; width: 25%; transform: translate(-150%,0%);" />
                </div>

                <div class="text-start">
                    <span class="fs-2 text-uppercase oswald-bold">{{ show.name }}</span>
                    <span class="fs-5 d-block oswald-bold">{{ show.date_text }}</span>
                    <p class="m-0 py-1">{{ show.description }}</p>
                    <p class="m-0 text-uppercase py-2">
                        <a :href="`${show.fw_link}`" class="cardlink"> Buy Tickets <i
                                class="fa-solid fa-arrow-right"></i></a>
                    </p>
                </div>
            </div>
            <div class="d-flex align-items-center justify-content-center pt-5 pb-5">
                <a :href="`${$TICKETS_URL}`">
                    <div class="btn px-3 text-uppercase dark-btn" type="button">All shows & Events</div>
                </a>
            </div>
        </div>
    </div>
</template>


<script>
import axios from 'axios';

export default {
    name: 'Upcoming Shows',
    data() {
        return {
            showsData: null,
        };
    },
    methods: {
        async fetchShowData() {
            const url = this.$API_GRAPHQL;
            try {
                const response = await axios.post(url, {
                    query: `
                      query {
                        show (filter: { featured: {  _eq: true } } ){
                          id
                          name,
                          date_text,
                          family_friendly,
                          description
                          fw_link
                          banner_image{
                            id
                          }
                        }
                      }
                    `
                }, {
                    headers: {
                        'Authorization': `Bearer Pm4Nd5_e46HaK2xtkPcla2PMBzbk9AQf`,
                        'Content-Type': 'application/json'
                    }
                });

                this.showsData = response.data.data.show;
                console.log('Home Page Data:', this.showsData);
            } catch (error) {
                console.error('Error fetching home page data:', error);
            }
        },
        getBackgroundColor(index) {
            const colors = ['#017B4A', '#1DB1D9', '#BB4A8C'];
            return { backgroundColor: colors[index % colors.length] };
        }
    },
    created() {
        console.log('Home component created, count:', this.count);
        this.fetchShowData();
    },
    updated() {
        console.log('Home component updated, count:', this.count);
    }
};
</script>
